<h1 class="product-name">
  {{ product.product_name }}
  <div>
    <span class="product-category" *ngFor="let c of product.categories">
      {{ c.product_category }}
    </span>
  </div>
</h1>

<div class="images mb-3">
  <img
    *ngFor="let img of product.images"
    src="{{ url + '/file?f=' + img.thumburl }}"
    alt=""
  />
</div>

<div class="row">
  <div class="product-details">
    <fieldset class="product-desc">
      <legend>Overview</legend>
      <div class="pfont" [innerHTML]="product.product_description"></div>
    </fieldset>

    <fieldset
      class="product-spec"
      *ngIf="product.product_specifications.length > 0"
    >
      <legend>Product Specifications</legend>
      <div class="specs">
        <div *ngFor="let spec of product.product_specifications">
          <span class="label">{{ spec.label }}</span>
          <span class="value">{{ spec.value }}</span>
        </div>
      </div>
    </fieldset>

    <fieldset class="product-variants">
      <legend>Product Variants</legend>
      <div class="variants">
        <div class="variant" *ngFor="let v of product.variants">
          <span class="label"> {{ v.name }} </span>
          <ul class="terms">
            <li *ngFor="let vt of v.terms">
              {{ vt.term }}
            </li>
          </ul>
        </div>
      </div>
    </fieldset>

    <!-- <div class="product-details" *ngIf="product.product_details.length > 0"> -->
    <fieldset *ngFor="let pd of product.product_details">
      <legend> {{ pd.title }} </legend>
      <ul class="product-details">
        <li *ngFor="let dtl of pd.list">
          {{ dtl }}
        </li>
      </ul>
    </fieldset>
    <!-- </div> -->
  </div>
</div>

<div class="row tiered-pricing" *ngIf="tieredPricing && tieredPricing.length > 0">
  <div class="col-md-12" *ngIf="settingsSvc.masterfile$ | async as settings">
    <fieldset>
      <legend>Tiered Pricing</legend>
      <table class="table table-bordered" *ngIf="settings.LOGISTICS">
        <thead>
          <tr>
            <th [translate]="'GENERAL.QUANTITY'">QUANTITY</th>
            <th *ngIf="product.logistic_1">
              {{ settings.LOGISTICS[product.logistic_1] | translate }}
            </th>
            <th *ngIf="product.logistic_2">
              {{ settings.LOGISTICS[product.logistic_2] | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tp of tieredPricing; let i = index">
            <td>{{ tp.quantity }}</td>
            <td *ngIf="tp.logistic_1">
              {{ tp.logistic_1 | currency: '' : 'symbol' : '1.2-4' }}
              <span class="text-success font-500">
                [{{
                  tp.logistic_1 +
                    (tp.logistic_1 * tp.logistic_1_markup.markup) / 100
                    | currency: '' : 'symbol' : '1.2-4'
                }}]
              </span>
            </td>
            <td *ngIf="tp.logistic_2">
              {{ tp.logistic_2 | currency: '' : 'symbol' : '1.2-4' }}
              <span class="text-success font-500">
                [{{
                  tp.logistic_2 +
                    (tp.logistic_2 * tp.logistic_2_markup.markup) / 100
                    | currency: '' : 'symbol' : '1.2-4'
                }}]
              </span>
            </td>
          </tr>
        </tbody>
        <tbody *ngFor="let vp of variantPricing">
          <tr>
            <td colspan="3" class="tp-variant">
              <div class="variant" *ngFor="let v of vp.variants | keyvalue">
                {{ v.key }}: {{ v.value }}
              </div>
            </td>
          </tr>
          <tr *ngFor="let tp of vp.pricing; let i = index">
            <td>{{ tp.quantity }}</td>
            <td *ngIf="tp.logistic_1">
              {{ tp.logistic_1 | currency: '' : 'symbol' : '1.2-4' }}
              <span class="text-success font-500">
                [{{
                  tp.logistic_1 +
                    (tp.logistic_1 * tp.logistic_1_markup.markup) / 100
                    | currency: '' : 'symbol' : '1.2-4'
                }}]
              </span>
            </td>
            <td *ngIf="tp.logistic_2">
              {{ tp.logistic_2 | currency: '' : 'symbol' : '1.2-4' }}
              <span class="text-success font-500">
                [{{
                  tp.logistic_2 +
                    (tp.logistic_2 * tp.logistic_2_markup.markup) / 100
                    | currency: '' : 'symbol' : '1.2-4'
                }}]
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </div>
</div>
